import { reduce } from "et3-type-guards";

import configuration from "../../configuration/keys";
import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Image from "../../core/et3-Image";
import Et3Text from "../../core/et3-text";
import {
  LOGIN_BRAND_BACKDROP,
  LOGIN_BRAND_FOOTNOTE_FONT_SIZE,
  LOGIN_BRAND_FOOTNOTE_OPACITY,
  LOGIN_BRAND_HEADLINE_FONT_SIZE,
  LOGIN_BRAND_LOGO_SIZE,
  LOGIN_BRAND_LOGO_WIDTH_CSS,
  LOGIN_BRAND_PADDING_X_CSS,
  LOGIN_BRAND_PADDING_Y_CSS,
  LOGIN_BRAND_PANEL_WIDTH,
  LOGIN_BRAND_TAGLINE_FONT_SIZE,
  LOGIN_BRAND_TAGLINE_LINE_HEIGHT,
  LOGIN_BRAND_TAGLINE_OPACITY,
  LOGIN_BRAND_TEXT_BLOCK_WIDTH,
  LOGIN_BRAND_TEXT_GAP_CSS,
  LOGIN_FULL_HEIGHT_CSS,
  LOGIN_FULL_WIDTH_CSS,
  LOGIN_HEADING_MIN_FONT_PX,
  LOGIN_LOGO_MONOCHROME_FILTER,
  LOGIN_NO_MINIMUM_CSS,
  LOGIN_SCREEN_HEIGHT,
  LOGIN_TEXT_MIN_FONT_PX
} from "./login-constants";
import {
  getFlooredFontSize,
  getLoginBrandWidthFromStore
} from "./login-layout";

const BrandPanel = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, getFontSize } = theme;
  const brandWidth = getLoginBrandWidthFromStore();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={LOGIN_BRAND_PANEL_WIDTH}
      height={LOGIN_SCREEN_HEIGHT}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="space-between"
      color={colors.all.maastrichtBlue}
      style={{
        boxSizing: "border-box",
        backgroundImage: LOGIN_BRAND_BACKDROP,
        flexShrink: 0,
        width: brandWidth,
        minWidth: LOGIN_NO_MINIMUM_CSS,
        height: LOGIN_FULL_HEIGHT_CSS,
        minHeight: LOGIN_NO_MINIMUM_CSS,
        paddingLeft: LOGIN_BRAND_PADDING_X_CSS,
        paddingRight: LOGIN_BRAND_PADDING_X_CSS,
        paddingTop: LOGIN_BRAND_PADDING_Y_CSS,
        paddingBottom: LOGIN_BRAND_PADDING_Y_CSS,
        overflow: "hidden"
      }}
      onClick={() => {}}
    >
      <Et3Image
        type="LOCAL"
        alt={i18n.get("ALKHATTABA_ADMIN")}
        imageName={"et3-logo"}
        size={LOGIN_BRAND_LOGO_SIZE}
        onClick={() => {}}
        style={{
          filter: LOGIN_LOGO_MONOCHROME_FILTER,
          width: LOGIN_BRAND_LOGO_WIDTH_CSS,
          maxWidth: LOGIN_FULL_WIDTH_CSS,
          height: "auto"
        }}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={LOGIN_BRAND_TEXT_BLOCK_WIDTH}
        height={0}
        fDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        color={colors.all.transparent}
        style={{
          width: LOGIN_FULL_WIDTH_CSS,
          minWidth: LOGIN_NO_MINIMUM_CSS,
          gap: LOGIN_BRAND_TEXT_GAP_CSS
        }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={LOGIN_BRAND_HEADLINE_FONT_SIZE}
          text={i18n.get("ALKHATTABA_ADMIN")}
          isSpan={false}
          color={colors.all.white}
          style={{
            margin: 0,
            textAlign: "left",
            fontSize: getFlooredFontSize(
              getFontSize(LOGIN_BRAND_HEADLINE_FONT_SIZE),
              LOGIN_HEADING_MIN_FONT_PX
            )
          }}
        />
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={LOGIN_BRAND_TAGLINE_FONT_SIZE}
          text={i18n.get("LOGIN_TAGLINE")}
          isSpan={false}
          color={colors.all.white}
          style={{
            margin: 0,
            textAlign: "left",
            opacity: LOGIN_BRAND_TAGLINE_OPACITY,
            lineHeight: LOGIN_BRAND_TAGLINE_LINE_HEIGHT,
            fontSize: getFlooredFontSize(
              getFontSize(LOGIN_BRAND_TAGLINE_FONT_SIZE),
              LOGIN_TEXT_MIN_FONT_PX
            )
          }}
        />
      </ET3Div>
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={LOGIN_BRAND_FOOTNOTE_FONT_SIZE}
        text={`${i18n.get("COPYRIGHT")} ${i18n.get("ET3ARRAF_SAL")} ${i18n.get(
          "ALL_RIGHTS_RESERVED"
        )} ${i18n.get("VERSION")} ${reduce(() => configuration.version, "")}`}
        isSpan={false}
        color={colors.all.white}
        style={{
          margin: 0,
          textAlign: "left",
          opacity: LOGIN_BRAND_FOOTNOTE_OPACITY,
          fontSize: getFlooredFontSize(
            getFontSize(LOGIN_BRAND_FOOTNOTE_FONT_SIZE),
            LOGIN_TEXT_MIN_FONT_PX
          )
        }}
      />
    </ET3Div>
  );
});
export default BrandPanel;
